import { useEffect, useState } from 'react'

import type {Document} from '@ui/components/CardDocumenti'


export function useDocuments(servizi: 'PREVENTIVO' | 'SERVIZI') {
	const [docs, setDocs] = useState<Array<Document> | null>([])
//console.log('VITE_DOCS_SERVIZI:', import.meta.env.VITE_DOCS_SERVIZI)
//console.log('ALL ENV:', import.meta.env)


	useEffect(() => {
		if (
			import.meta.env.VITE_DOCS_URL ||
			import.meta.env.VITE_DOCS_SERVIZI ||
			import.meta.env.VITE_PREVENTIVATORE
		) {
			const endpoint =
				servizi === 'SERVIZI'
					? import.meta.env.VITE_DOCS_SERVIZI
					: import.meta.env.VITE_DOCS_URL

			fetch(endpoint).then(async (res) => {
               
				const jsonResponse: Array<Document> = (await res.json()).map(
					(document: Document) => ({
						...document,
						FileRef: `${import.meta.env.VITE_PREVENTIVATORE}${
							document.FileRef
						}`,
					})
				)

				setDocs(
					jsonResponse.length > 0
						? jsonResponse.sort(
								(a, b) =>
									a.Ordine_x0020_Preventivatore - b.Ordine_x0020_Preventivatore
						  )
						: null
				)
			})
		} else {
			console.error('endpoint documenti non specificato')
		}
	}, [])

	return docs
}
